import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface MoreLessGroupPropsType {
    variant: DefaultComponentVariantType | null;
}

const setMoreLessGroup = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin-top: 4px;
            border-radius: ${theme.star.radius.medium};
        `;
    }
    return css`
        border-top: solid 1px ${theme.star.moreLessButton.borderColor};
        margin-top: -1px; /* 1 */
    `;
};
/* 1 - You can delete this if z-index will be deleted in Selection component */
export const MoreLessGroup = withConfig(theme => styled('div', { label: 'MoreLessGroup' })<MoreLessGroupPropsType>`
    ${({ variant }): SerializedStyles => setMoreLessGroup(variant, theme)}
    background-color: ${theme.star.moreLessButton.bgColor};
    text-align: center;
    position: relative; /* 1 */
`);

interface LinkMoreLessWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setLinkMoreLessWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            align-items: center;
            background: transparent;
            color: ${theme.star.moreLessButton.txtColor};
            justify-content: center;
            display: inline-flex;
            &:hover {
                background: ${theme.star.moreLessButton.bgColorSecondary};
                color: ${theme.star.moreLessButton.txtColorSecondary};
            }
        `;
    }
    return css`
        background-color: ${theme.star.marketHeader.bgColor};
        color: ${theme.star.marketHeader.txtColor};
        display: inline-block;
        &:hover {
            background-color: ${theme.star.marketHeader.bgColorSecondary};
            color: ${theme.star.marketHeader.txtColor};
        }
    `;
};

export const LinkMoreLessWrapper = withConfig(theme => styled('button', { label: 'LinkMoreLessWrapper' })<LinkMoreLessWrapperPropsType>`
    ${({ variant }): SerializedStyles => setLinkMoreLessWrapper(variant, theme)}
    border: 0;
    cursor: pointer;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.3334;
    padding: 12px 10px;
    position: relative;
    text-decoration: none;
    transition: background-color .35s ease, color .35s ease;
    width: 100%;
`);

interface SelectionsGroupPropsType {
    variant: DefaultComponentVariantType | null;
}

export const SelectionsGroup = withConfig(theme => styled('section', { label: 'SelectionsGroup' })<SelectionsGroupPropsType>`
    align-items: flex-start;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    width: 100%;
    gap: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.gap.small : '0'};
`);

export const SelectionList = styled('ul', { label: 'SelectionList' })`
    border-right: 0;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    width: 100%;
`;

export const EachWayDetails = withConfig(theme => styled('ul', { label: 'EachWayDetails' })`
    font-size: ${theme.star.fontSize.xSmall};
    line-height: 1.2;
    font-weight: ${theme.star.fontWeight.xMedium};
    gap: 4px;
    display: flex;
    justify-content: flex-end;
    margin: 0;
    white-space: nowrap;
`);
